export const BellIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      stroke="currentColor"
      {...props}
    >
      <path
        id="Vector"
        d="M0 13.5V12H1V7C1 5.79167 1.37153 4.72917 2.11458 3.8125C2.85764 2.89583 3.81944 2.32639 5 2.10417V1C5 0.722222 5.09722 0.486111 5.29167 0.291667C5.48611 0.0972222 5.72222 0 6 0C6.27778 0 6.51389 0.0972222 6.70833 0.291667C6.90278 0.486111 7 0.722222 7 1V2.10417C8.18056 2.32639 9.14236 2.89583 9.88542 3.8125C10.6285 4.72917 11 5.79167 11 7V12H12V13.5H0ZM5.99563 16C5.58188 16 5.22917 15.8531 4.9375 15.5594C4.64583 15.2656 4.5 14.9125 4.5 14.5H7.5C7.5 14.9167 7.35271 15.2708 7.05812 15.5625C6.76354 15.8542 6.40938 16 5.99563 16ZM2.5 12H9.5V7C9.5 6.02778 9.15972 5.20139 8.47917 4.52083C7.79861 3.84028 6.97222 3.5 6 3.5C5.02778 3.5 4.20139 3.84028 3.52083 4.52083C2.84028 5.20139 2.5 6.02778 2.5 7V12Z"
      />
    </svg>
  );
};
